import {
  STORE_PROPERTY,
  STORE_RECENT_SAVED_PROPERTIES,
  STORE_SAVED_PROPERTY_IDENTIFIERS,
  UPDATE_PROPERTY_LISTING,
} from '../constants/actionTypes'

export const storeProperty = (property, isTrustee) => ({
  type: STORE_PROPERTY,
  isTrustee,
  property,
})

export const storeRecentSavedProperties = properties => ({
  type: STORE_RECENT_SAVED_PROPERTIES,
  properties,
})

export const storeSavedPropertyIdentifiers = identifiers => ({
  type: STORE_SAVED_PROPERTY_IDENTIFIERS,
  identifiers,
})
export const updatePropertyListing = listing => ({
  type: UPDATE_PROPERTY_LISTING,
  listing,
})
